import { getCustomers } from "../services/customerService";
import { useQuery } from "@tanstack/react-query";

const useCustomers = () => useQuery({
    queryKey: ['customers'],
    queryFn: () => getCustomers().then(res => res.data),
    staleTime: 1000 * 60 * 15 // 15 min
});

export default useCustomers;